import DonateComponent from "@/components/Donate/DonateComponent";

const Donate = () => {
  return <DonateComponent />;
};

export default Donate;
